module.exports = __webpack_public_path__ + "92109eca448b1706801493a3db48c7ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_40.jpg
// module id = 1712
// module chunks = 5